import { metaAccount } from '@/router/meta-config'
// !FOR DEV!
const permissionKey = 'ACCOUNT'

export default [
  {
    path: '/shared-access',
    name: 'page-shared-access',
    component: () => import('@/pages/shared-access'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
  // {
  //   path: '/seo-config/new',
  //   name: 'page-seo-config-new',
  //   component: () => import('@/pages/seo-config'),
  //   meta: {
  //     ...metaAccount,
  //     permissionKey
  //   }
  // },
  // {
  //   path: '/seo-config/:id',
  //   name: 'page-seo-config',
  //   component: () => import('@/pages/seo-config'),
  //   props: (route) => ({ id: route.params.id }),
  //   meta: {
  //     ...metaAccount,
  //     permissionKey
  //   }
  // }
]
